import React, { createContext, useState, useEffect } from 'react';

export const ClientContext = createContext();

export const ClientContextProvider = ({ children }) => {
  const [stepCompletionStatus, setStepCompletionStatus] = useState({});

  const updateStepCompletionStatus = (stepIndex, isSuccess) => {
    console.log(`Updating step ${stepIndex} completion status to ${isSuccess}`);
    setStepCompletionStatus(prevState => {
      const newState = { ...prevState, [stepIndex]: isSuccess };
      const applicationID = localStorage.getItem('currentApplicationID');
      
      if (applicationID) {
        const ongoingApplications = JSON.parse(localStorage.getItem('ongoingApplications')) || [];
        const applicationToUpdate = ongoingApplications.find(app => app.id === applicationID);
        
        if (applicationToUpdate) {
          applicationToUpdate.formSubmissionStatus = {
            ...applicationToUpdate.formSubmissionStatus,
            [stepIndex]: isSuccess
          };
          localStorage.setItem('ongoingApplications', JSON.stringify(ongoingApplications));
        }
      }
      
      return newState;
    });
  };

  // FIXED: This useEffect should reset completion status for uncompleted applications
  useEffect(() => {
    const applicationID = localStorage.getItem('currentApplicationID');
    console.log('ClientContext - Loading for application:', applicationID);
    
    if (applicationID) {
      const ongoingApplications = JSON.parse(localStorage.getItem('ongoingApplications')) || [];
      const application = ongoingApplications.find(app => app.id === applicationID);
      
      // Always reset to empty if no status exists OR force reset
      if (application && application.formSubmissionStatus) {
        // Check if we should reset (e.g., based on application status)
        if (application.status === "Uncompleted") {
          // Reset to empty for uncompleted applications
          console.log('ClientContext - Resetting status for uncompleted application');
          setStepCompletionStatus({});
        } else {
          console.log('ClientContext - Loading existing formSubmissionStatus:', application.formSubmissionStatus);
          setStepCompletionStatus(application.formSubmissionStatus);
        }
      } else {
        console.log('ClientContext - No formSubmissionStatus found, setting empty');
        setStepCompletionStatus({}); // Explicitly set empty
      }
    } else {
      console.log('ClientContext - No applicationID found, setting empty');
      setStepCompletionStatus({}); // No application = empty
    }
  }, []);

  return (
    <ClientContext.Provider value={{ stepCompletionStatus, updateStepCompletionStatus }}>
      {children}
    </ClientContext.Provider>
  );
};